import { render, staticRenderFns } from "./NewsAndTutorialsPanel.vue?vue&type=template&id=315aa4d2&scoped=true&"
import script from "./NewsAndTutorialsPanel.vue?vue&type=script&lang=js&"
export * from "./NewsAndTutorialsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NewsAndTutorialsPanel.vue?vue&type=style&index=0&id=315aa4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315aa4d2",
  null
  
)

export default component.exports